import React, { useEffect, useState } from "react";
import { Popup } from "devextreme-react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useSelector } from "react-redux";
import { handleGetLocal } from "../../../../../services/auth-service";
import { Table1 } from "../../../../Administration/Table1/Table1";
import { logOut } from "../../../../../components/Logout";
import AddEditEMPeriodPopup from "../../G0ToObligation/GoTOObligationSubTabs/Monitoring/MonitoringPopup/AddEditEMPeriodPopup";
import { GoTOObligationFunction } from "../../G0ToObligation/GoTOObligationFunction";
import { MonitoringFunction } from "../../../../Monitoring/MonitoringFunction";
import { EMPTY_SELECTIONRANGE } from "@progress/kendo-react-dateinputs";
// import { EMFunction } from "../../EM/EmPopup/EMFunction";
import { EmFunction } from "../../EM/EmFunction";


const MonitoringPeriods = ({ userinfo}) => {
    const [loading, setLoading] = useState(false);
    const [exportPopupOpen, setexportPopupOpen] = useState(false);
    const [addEditEMPeriodPopup, setAddEditEMPeriodPopup] = useState(false);
    const [voidAlertPopup, setVoidAlertPopup] = useState(false);
    const [typeTab, SetTypeTab] = useState("");
    const [rowLevelData, setRowLevelData] = useState([]);
    const navigate = useNavigate();
    const pathname = handleGetLocal("pathURL");
    const [emPeriodTableData, setEmPeriodTableData] = useState([]);
    const [obligationDropdownData, setObligationDropdownData] = useState([]);
    const [equipmentTypeDropdownData, setEquipmentTypeDropdownData] = useState([]);
    const [emTypeDropdownData, setEmTypeDropdownData] = useState([]);
    const [frequencyDropdownData, setFrequencyDropdownData] = useState([]);
    const [paymentTypeDropdownData, setPaymentTypeDropdownData] = useState([]);
    const [endReasonDropdownData, setEndReasonDropdownData] = useState([]);
    const [returnStatusDropdown,setReturnStatusDropdown] = useState([]);
    const [equipmentStatusDropdown,setEquipmentStatusDropdown] = useState([])
    const [toastConfig, setToastConfig] = useState({
        isVisible: false,
        type: "",
        message: "",
    });

    const apiClass = new GoTOObligationFunction();
    const ApiClass = new MonitoringFunction();
    // const emApiClass = new EMFunction();
    const emApiClass = new EmFunction();
    
    const { gotooblogationValue } = useSelector((store) => store.participateNotes);

    const { dockerValue } = useSelector((store) => store.participateNotes);

    const convertDateFormat = (dateString) => {
        if (dateString) {
            const dateObj = new Date(dateString);
            return dateObj.toLocaleDateString("en-US");
        } else {
            return "";
        }
    };

    const emPeriodTabelColumn = [
        { title: "", moreoption: true, customwidth: "50px" },
        { title: "Ref" },
        { title: "Obligation" },
        { title: "Equipment Type" },
        { title: "Rate Start", date: true },
        { title: "Rate End", date: true },
        { title: "Rate", currency: true },
        { title: "Frequency" },
        { title: "Days Active" },
        { title: "Amount", currency: true },
        { title: "Void", bool: true },
        { title: "Payment Agency(Entity)" }
    ];

    const setEmPeriodObligationTableData = (data) => {
        const arr = [];
        data.map((val, i) => {
            var date1 = new Date(val?.dRateStart);
            var date2 = new Date(val?.dRateEnd);
            var differenceInMilliseconds = Math.abs(date2 - date1);
            var differenceInDays = Math.ceil(differenceInMilliseconds / (1000 * 3600 * 24));
            arr.push({
                Ref: val?.sReference,
                Obligation: val?.sDdsviolationDescription,
                'Equipment Type': val?.sEquipmentTypeName,
                "Rate Start": convertDateFormat(val?.dRateStart),
                "Rate End": convertDateFormat(val?.dRateEnd),
                Rate: val?.fRate,
                Frequency: val?.sRateFrequencyName,
                "Days Active": val?.iDaysActive,
                Amount: val?.iDaysActive * val?.fRate,
                Void: val.bVoid || false,
                "Payment Agency(Entity)": val?.sBillingAgency,
                dStart: convertDateFormat(val?.dStart),
                dEnd: convertDateFormat(val?.dEnd),
                ID: i,
                gDocketId: val?.gDocketId,
                gEmTypeId: val?.gEmTypeId,
                gPeriodId: val?.gEmPeriodId,
                gRateFrequencyId: val?.gRateFrequencyId,
                gPeriodObligationId: val?.gPeriodObligationId,
                sPaymentTypeName: val?.sPaymentTypeName,
                sPaymentTypeId: val?.gEmPaymentTypeId,
                gObligationId: val?.gObligationId,
                gEquipmentTypeId: val?.gEmEquipmentTypeId,
                gPersonId: userinfo?.gPersonId,
            });
        });
        return arr;
    };

    const getMonitoringPeriodsTableData = async (gPersonId) => {
        setLoading(true);
        await axios
            .get(`${process.env.REACT_APP_API_URL}/api/em/monitoring-period-get?gPersonId=${gPersonId}`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("authToken")}`,
                    Domain: `${pathname}`,
                },
            })
            .then((val) => {
                setEmPeriodTableData(setEmPeriodObligationTableData(val?.data?.data));
                setLoading(false);
            })
            .catch((val) => {
                setLoading(false);
                if (!val?.response) {
                    navigate(`/error/500`);
                } else if (val?.response?.status === 401) {
                    logOut();
                }
            });
    };

    const emPeriodDataApi = () => {
        apiClass.getEmPeriodObligationTableData(setLoading, navigate, rowLevelData?.gObligationId, setEmPeriodTableData);
    };

    console.log('userinfo', userinfo)
   

    useEffect(() => {
        getMonitoringPeriodsTableData(userinfo.gPersonId);
        apiClass.getObligationDropdownData(navigate, userinfo.gPersonId, setObligationDropdownData);
        ApiClass.getEquipmentTypeDropdownApi(setLoading, navigate, setEquipmentTypeDropdownData);
        emApiClass.getEqipmentDropdownApi(setLoading, navigate,setReturnStatusDropdown, setEquipmentStatusDropdown, setEndReasonDropdownData);
        apiClass.getEmPeriodDropdownData(
            navigate,
            setFrequencyDropdownData,
            setEmTypeDropdownData,
            setPaymentTypeDropdownData,
            setEquipmentTypeDropdownData
        );        
    }, []);
    return (
        <>
            <Popup
                visible={addEditEMPeriodPopup}
                onHiding={() => {
                    setAddEditEMPeriodPopup(!addEditEMPeriodPopup);
                }}
                showTitle={false}
                width={700}
                // height={858}
                height="auto"
                showCloseButton={true}
                hideOnOutsideClick={false}
            >
                
                <AddEditEMPeriodPopup
                    addEditEMPeriodPopup={addEditEMPeriodPopup}
                    setAddEditEMPeriodPopup={setAddEditEMPeriodPopup}
                    setToastConfig={setToastConfig}
                    toastConfig={toastConfig}
                    setLoading={setLoading}
                    typeTab={typeTab}
                    // height="859px"
                    height="auto"
                    rowLevelData={rowLevelData}
                    gObligationID={rowLevelData.gObligationId}
                    emTypeDropdownData={emTypeDropdownData}
                    frequencyDropdownData={frequencyDropdownData}
                    refreshApi={emPeriodDataApi}
                    gotooblogationValue={gotooblogationValue}
                    paymentTypeDropdownData={paymentTypeDropdownData}
                    obligationDropdownData={obligationDropdownData}
                    equipmentTypeDropdownData={equipmentTypeDropdownData}
                    endReasonDropdownData={endReasonDropdownData}
                    returnStatusDropdown={returnStatusDropdown}
                    equipmentStatusDropdown={equipmentStatusDropdown}
                    isAccrual={true}
                />
            </Popup>
            <div className="recipients-table-section">
                <div className="buttons">
                    <button
                        className="btn"
                        onClick={() => {
                            setexportPopupOpen(true);
                        }}
                    >
                        Export
                        <svg
                            className="svg-blue-white"
                            width="14"
                            height="17"
                            viewBox="0 0 14 17"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M11.59 6H10V1C10 0.45 9.55 0 9 0H5C4.45 0 4 0.45 4 1V6H2.41C1.52 6 1.07 7.08 1.7 7.71L6.29 12.3C6.68 12.69 7.31 12.69 7.7 12.3L12.29 7.71C12.92 7.08 12.48 6 11.59 6ZM0 16C0 16.55 0.45 17 1 17H13C13.55 17 14 16.55 14 16C14 15.45 13.55 15 13 15H1C0.45 15 0 15.45 0 16Z"
                                fill="#424167"
                            />
                        </svg>
                    </button>
                </div>
                <div className="table">
                    <Table1
                        editTable={false}
                        height={"auto"}
                        Tablecoloum={emPeriodTabelColumn}
                        tableRow={emPeriodTableData}
                        load={loading}
                        coloumWidthText={"EM Period Obligation"}
                        mandatoryColoum={"Amount"}
                        exportInDifferentFormate={true}
                        exportPopupOpen={exportPopupOpen}
                        setexportPopupOpen={setexportPopupOpen}
                        exportwidth={27}
                        exporttitle={"Monitoring Periods"}
                        SetTypeTab={SetTypeTab}
                        setAddEditEMPeriodPopup={setAddEditEMPeriodPopup}
                        MontoringPeriodMenu={true}
                        setRowLevelData={setRowLevelData}
                        setVoidAlertPopup={setVoidAlertPopup}
                        setVoideFalse={true}
                    />
                </div>
            </div>
        </>
    );
};

export default MonitoringPeriods;
